import React, { useState } from "react";
import QRCode from "react-qr-code";
import { toast } from "sonner";
import { Copy, Share2, Users, CheckCircle2, Award, Gift } from "lucide-react";

const STATS = [
  { label: "Invited", value: "12", icon: Users },
  { label: "Joined", value: "5", icon: CheckCircle2 },
  { label: "Qualified", value: "2", icon: Award },
  { label: "Bonuses Earned", value: "$50", icon: Gift },
];

export default function Referrals() {
  const link = "spotbounty.com/r/alex-j";
  const code = "ALEXJ25";
  const [copied, setCopied] = useState("");
  const copy = (v, k) => {
    navigator.clipboard?.writeText(v).catch(() => {});
    setCopied(k); setTimeout(() => setCopied(""), 1500);
    toast.success("Copied to clipboard.");
  };

  return (
    <div className="p-4 pb-6">
      <h1 className="sb-headline text-[28px]">
        INVITE FRIENDS.
        <br />EARN <span className="text-[#FFC107]">MORE.</span>
      </h1>

      <div className="mt-5 sb-card p-5">
        <div className="sb-eyebrow" style={{ fontSize: 10 }}>Your Referral Link</div>
        <div className="mt-2 flex items-center gap-2">
          <div className="sb-mono text-[12px] flex-1 truncate">{link}</div>
          <button onClick={() => copy(`https://${link}`, "link")} className="sb-pill sb-pill-gray"><Copy size={11} /> {copied === "link" ? "Copied" : "Copy"}</button>
        </div>
        <div className="mt-4 pt-4 border-t border-[#2A2F34] flex items-center gap-4">
          <div className="p-2 bg-white rounded-md">
            <QRCode value={`https://${link}`} size={80} bgColor="#ffffff" fgColor="#080B0D" />
          </div>
          <div className="flex-1">
            <div className="sb-eyebrow" style={{ fontSize: 10 }}>Code</div>
            <div className="mt-1 text-[20px] font-black tracking-widest">{code}</div>
            <div className="mt-2 flex gap-2">
              <button onClick={() => copy(code, "code")} className="sb-pill sb-pill-gray text-[10px]"><Copy size={10} /> Copy code</button>
              <button className="sb-pill sb-pill-gray text-[10px]"><Share2 size={10} /> Share</button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3">
        {STATS.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className="sb-card p-4">
              <Icon size={16} className="text-[#FFC107]" />
              <div className="mt-2 text-[20px] font-black">{s.value}</div>
              <div className="sb-eyebrow mt-0.5" style={{ fontSize: 9 }}>{s.label}</div>
            </div>
          );
        })}
      </div>

      <div className="mt-5 sb-card p-4">
        <div className="sb-eyebrow">How rewards work</div>
        <p className="mt-2 text-[12px] text-[#A1A1AA] leading-relaxed">
          Referral rewards are earned only after qualifying revenue activity. Example: Referring Scout earns $25 after
          the referred Scout's first successful sold location. New Scout earns $25 First Bounty Bonus after their
          first successful sold location. Amounts shown are sample values and are configurable.
        </p>
      </div>
    </div>
  );
}
